export const truncateWords = (text: string, charLimit: number): string => {
  return text.length > charLimit
    ? text.substring(0, charLimit) + '...'
    : text;
};
